import * as API from "../api";
export const FETCH_INITIAL_STATE = "FETCH_INITIAL_STATE";
export const FETCH_LICENSES = "FETCH_LICENSES";
export const FETCHING_LICENSES = "FETCHING_LICENSES";
export const FETCH_LICENSE = "FETCH_LICENSE";
export const FETCHING_LICENSE = "FETCHING_LICENSE";
export const FETCH_LICENSE_ERROR = "FETCH_LICENSE_ERROR";
export const FETCH_LICENSES_ERROR = "FETCH_LICENSES_ERROR";
export const FETCHING_LICENSE_AREAS = 'FETCHING_LICENSE_AREAS'
export const FETCH_LICENSE_AREAS = 'FETCH_LICENSE_AREAS'
export const FETCH_LICENSE_AREAS_ERROR = 'FETCH_LICENSE_AREAS_ERROR'

export const fetchInitialState = () => {
  return dispatch => {
    dispatch({ type: FETCH_INITIAL_STATE, value: false })
  }
}

export const fetchLicenses = (areaId, term, thirdParties) => {
  return dispatch => {
    dispatch({ type: FETCHING_LICENSES, value: true });
    return API.license
      .getLicenses(areaId, term, thirdParties)
      .then(response => {
        dispatch({
          type: FETCH_LICENSES,
          items: (response.data || {}).items,
          last_update: (response.data || {}).last_update
        });
      })
      .catch(err => {
        dispatch({ type: FETCH_LICENSES_ERROR });
      });
  };
};

export const fetchLicense = id => {
  return dispatch => {
    dispatch({ type: FETCHING_LICENSE, value: true });
    return API.license
      .getLicense(id)
      .then(response => {
        const data = response.data;
        dispatch({ type: FETCH_LICENSE, license: data });
      })
      .catch(err => {
        dispatch({ type: FETCH_LICENSE_ERROR });
      });
  };
};

export const fetchLicensesForArea = (areaId, term, thirdParties) => {
  return dispatch => {
    dispatch({ type: FETCHING_LICENSES, value: true });
    return API.license
      .getLicensesForArea(areaId, term, thirdParties)
      .then(response => {
        dispatch({
          type: FETCH_LICENSES,
          items: (response.data || {}).items,
          last_update: (response.data || {}).last_update
        });
      })
      .catch(err => {
        dispatch({ type: FETCH_LICENSES_ERROR });
      });
  };
};

export const fetchAreasList = () => {
  return dispatch => {
    dispatch({ type: FETCHING_LICENSE_AREAS, value: true });
    return API.license
    .getRelationAreas()
    .then(({ data = {} }) => {
      const { areas } = data

      const areasList = areas.map( item => {
        return { label: item.name, value: item.id }
      })

      dispatch({
        type: FETCH_LICENSE_AREAS,
        areasList: areasList
      })
    })
    .catch( err => {
      dispatch({ type: FETCH_LICENSE_AREAS_ERROR, value: true })
    })
  }
}



// WEBPACK FOOTER //
// ./src/actions/license.js